import { templates } from './templates'

export default {
  ...templates
}
